module.exports = __webpack_public_path__ + "media/assets/FinchLogo-b902591266524792403e94e224dcc0d0.svg";